import template from './individualDetailsPreview.html';
import IndividualDetailsPreviewCtrl from './individualDetailsPreviewCtrl';

export default {
  template,
  controller: IndividualDetailsPreviewCtrl,
  controllerAs: 'vm',
};
